<mat-form-field>
  <mat-label>Select Billing Entity</mat-label>
  <mat-select [formControl]="billingEntityCtrl" [compareWith]="compareFn">
    <mat-select-trigger>
      {{ selectedEntity()?.from.name ?? '' }}
    </mat-select-trigger>

    @for (
      billingEntity of billingEntities$ | async;
      track billingEntity.from.name + billingEntity.from.taxId
    ) {
      <mat-option [value]="billingEntity">
        <div class="flex flex-col">
          <span>{{ billingEntity.from.name }}</span>
          <span class="text-sm opacity-60">
            {{ billingEntity.from.taxId }}
          </span>
        </div>
      </mat-option>
    }
  </mat-select>
</mat-form-field>
